/**
 * access.ts — the single, guarded gateway to the native bridges.
 *
 * Nothing in the dashboard should touch `window.omniDesktop` / `window.omniMobile`
 * directly. These accessors centralise the null-checks so a feature either gets a
 * typed bridge or a clear absence, and the capability façade stays the source of
 * truth for "should I even try".
 *
 * See Docs/architecture/26-electron-desktop-and-mobile-architecture.md §4.3.
 */

import type { OmniDesktopBridge, OmniMobileBridge } from "./bridge";

export function getDesktopBridge(): OmniDesktopBridge | null {
  return typeof window !== "undefined" && window.omniDesktop ? window.omniDesktop : null;
}

export function getMobileBridge(): OmniMobileBridge | null {
  return typeof window !== "undefined" && window.omniMobile ? window.omniMobile : null;
}

/** Throws if not running under Electron — use only behind a `useCapability` guard. */
export function requireDesktopBridge(): OmniDesktopBridge {
  const b = getDesktopBridge();
  if (!b) throw new Error("omniDesktop bridge unavailable (not running under Electron)");
  return b;
}
